





















import { defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api'

import SearchBar from '@/components/search-bar/SearchBar.vue'
import MapLocation from '@/classes/MapLocation'
import DateHourRange from '@/classes/DateHourRange'

import useFreezeBodyScroll from '@/composables/use-freeze-body-scroll'
import { SeatsValue } from '@/composables/use-seats'

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    location: {
      type: MapLocation as PropType<MapLocation | null>,
      default: null,
    },
    dateHourRange: {
      type: DateHourRange as PropType<DateHourRange>,
      default: (): DateHourRange => new DateHourRange(),
    },
    seats: {
      type: String as PropType<SeatsValue>,
      default: null,
    },
    filterCount: {
      type: Number as PropType<Number | null>,
      default: null,
    },
  },
  setup (props, { emit }) {
    const searchBar = ref<InstanceType<typeof SearchBar> | null>(null)

    const show = () => emit('input', true)
    const hide = () => emit('input', false)

    const clickActivator = ({ target }: { target: HTMLElement }) => {
      target.blur?.()
      show()
    }
    const clickFilter = ({ target }: { target: HTMLElement }) => {
      target.blur?.()
      emit('click-filter')
    }

    const { freeze, unfreeze } = useFreezeBodyScroll()
    watch(
      () => props.value,
      value => value ? freeze() : unfreeze(),
      { immediate: true }
    )

    return {
      searchBar,
      show,
      hide,
      clickActivator,
      clickFilter,
    }
  },
})
